import { createContext, useContext, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useLocalStorage } from "./useLocalStorage";
import useMasterContext from "Context/MasterContext";
export interface IUserInfo {
  user: any;
  login: any;
  logout: any;
}

interface IAuthProvider {
  children: any;
  userData: any;
}
const AuthContext = createContext<IUserInfo>({} as IUserInfo);

export const AuthProvider = ({ children, userData }: IAuthProvider) => {
  const { clearMasterData } = useMasterContext();
  const newObj = {
    keyName: "user",
    defaultValue: userData,
  };
  const [user, setUser] = useLocalStorage(newObj);
  const navigate = useNavigate();

  const login = async (data: any) => {
    setUser(data);
    navigate("/admin/dashboard", { replace: true });
  };

  const logout = () => {
    setUser(null);
    navigate("/", { replace: true });
    clearMasterData();
    localStorage.setItem("idToStreamName", "");
    localStorage.setItem("user_details", "");
    localStorage.removeItem("insightObject");
  };

  const value = useMemo(
    () => ({
      user,
      login,
      logout,
    }),
    [user]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  return useContext(AuthContext);
};
